export default __webpack_public_path__ + "static/media/BrainBreak cards99.653b49f6.png";